const getSelectedName = ({ selectedId, selectOptions }) => {
  if (!selectedId) {
    return 'empty assignment';
  }

  const selectedOption = selectOptions.find(
    ({ value }) => value === selectedId
  );

  if (!selectedOption || !selectedOption.name) {
    return 'empty assignment';
  }

  return selectedOption.name;
};

export default getSelectedName;
